export const transferEnterTheme = {
  bg: 'palette.surface.2',
  borderRadius: '12px',
  errorMessage: 'palette.error.60',
  subtitle: 'palette.tertiary.50',
  title: 'palette.tertiary.90',
};
